<template>
  <div class="product-detail" itemscope itemtype="https://schema.org/NewsArticle">
    <div class="title-box primary-box">
      <div class="title-box__back-container">
        <v-icon @click="goBack">mdi-chevron-left</v-icon>
      </div>
      <div class="title-box__title">
        <h2>{{ product.name }}</h2>
<!--        <p itemprop="headline" v-html="renderMarkdown(product.abstract ?? '')"></p>-->
      </div>
    </div>

    <!-- Clickable Product Image -->
    <v-img
        :src="product?.img?.formats?.medium?.url"
        alt="Product image"
        class="product-image"
        @click="fullscreenImage = true"
    ></v-img>

    <!-- Fullscreen Image Dialog -->
    <v-dialog v-model="fullscreenImage" transition="dialog-bottom-transition">
      <v-img :src="product?.img?.url" class="fullscreen-img"
             @click="fullscreenImage = false" eager></v-img>
    </v-dialog>

    <v-expansion-panels variant="popout" class="my-4" v-model="panels" :rounded="false">
      <v-expansion-panel :title="getTranslation(language, 'product-description')">
        <v-expansion-panel-text
            v-if="product.description"
            v-html="product.description + '<br/><p>⚠️ Trattandosi di un prodotto naturale può presentare leggere variazioni di peso, colore e conformazione.</p>' ?? ''"
            class="md-text-container"
        ></v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel :title="getTranslation(language, 'product-specs')">
        <v-expansion-panel-text
            v-if="product.specs"
            v-html="product.specs ?? ''"
            class="md-text-container"
        ></v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>


<script>
import apiService from "@/services/ApiService";
import {getTranslation} from "@/services/stringTableService";
import {defaultMeta, updateMetaInfo} from "@/middleware/metaUpdater";
// import MarkdownIt from "markdown-it";

export default {
  name: 'ProductDetail',
  props: {
    id: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      product: {},
      language: "IT",
      panels: [0],
      fullscreenImage: false
    }
  },
  async beforeMount() {
    // this.markdown = new MarkdownIt({
    //   html: true
    // });
    const product = await this.fetchProduct();
    updateMetaInfo(this.getMetaInfo(product));
  },
  methods: {
    getTranslation,
    // renderMarkdown(text) {
    //   if(!text) return "";
    //   if(!this.markdown) return text;
    //   return this.markdown.render(text);
    // },
    goBack() {
      this.$router.push('/#products-deck-id-' + this.product.id);
    },
    async fetchProduct() {
      const productId = this.$route.params.id;
      try {
          this.$store.dispatch('setLoading', true);
          const product = await apiService.getProduct(productId);
          this.product = product;
          return product;
          // this.updateUrlWithSlug(product);
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    stripHtmlTags(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    getMetaInfo(product){
      const productName = product?.name ?? "";
      const productDescription = product?.name + " - " +this.stripHtmlTags(product?.abstract ?? "");
      const productUrl = "https://masticaando.com" + this.$route.fullPath;
      return {
        title: `Masticando - ${productName}`,
        description: `${productDescription}`,
        author: "masticando.com",
        robots: "index, follow",
        keywords: defaultMeta.keywords + `,${productName.toLowerCase()}`,
        properties: [
          {property: 'og:title', content: "Masticando - " + productName},
          {property: 'og:description', content: productDescription},
          {property: 'og:image', content: product?.img?.url},
          {property: 'og:url', content: productUrl},
          {property: 'og:type', content: "website"},
        ]
        //keywords: `razza,razze,fci,enci,cani,cinofilia,${breedName}`
      };
    }
    // updateUrlWithSlug() {
    //   // this.$router.replace({
    //   //   name: 'ProductDetail',
    //   //   params: { id: data.id, slug: data.slug.get(this.language) },
    //   //
    //   // });
    // }
  },
  watch: {
    $route(to, from) {
      if(to.params.id !== from.params.id)
        this.fetchProduct();
    }
  }
}
</script>

<style lang="scss">
@import "../style/_variables.scss";
.md-text-container {
  flex-direction: column;
  text-align: left;
  padding: 20px;
  gap: 10px;
  font-size: 0.9rem;

  h2 {
    margin-top: 10px;
    font-size: 1.2rem;
    font-family: $header-font;
  }
  ul {
    list-style-type: disc;
    padding-left: 35px;
  }
}
.product-detail {
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: $secondary-background-color;
  .product-image {
    width: 50%;
    max-width: 500px;
    margin: 20px 0;
    border-radius: 20px;
  }
  .product-group {
    text-decoration: underline;
    cursor: pointer;
  }

  .divider {
    margin: 20px 0;
  }

  h1 {
    font-family: $header-font;
    font-size: 3rem;
    font-weight: bolder;
  }
  h2 {
    font-family: $header-font;
    font-weight: bolder;
  }

  .product-standard-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    a {
      color: $primary-color;
      text-decoration: underline;
      cursor: pointer;
    }
    .product-standard-container__link {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      gap: 10px;
    }
    .product-standard-container__pdf {
      flex-wrap: wrap;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      gap: 10px;
    }
  }
}

@media (max-width: 700px) {
  .product-detail {
    .product-image {
      width: 90%;
    }
  }
}
</style>